import {
  AUTH_EMAIL_LOGIN,
  AUTH_MAGIC_LINK_LOGIN,
  AUTH_MAGIC_LINK_LOGIN_RESEND
} from 'portal/constants/Routes';
import {
  buttonContainerStyles,
  ctaContainerStyles,
  linkButtonStyles,
  loginButtonStyles,
  loginNoticeStyles
} from 'auth/AuthStyles';
import { formatPhoneNumber } from 'helpers/FormattingHelper';
import { postData } from 'helpers/RequestHelper';
import AuthLayout from 'auth/AuthLayout';
import Button from '@opploans/button-component/Button';
import CheckPhone from 'images/ContainerIcons/CheckPhone.svg';
import LinkButton from '@opploans/link-button-component/LinkButton';
import React, { useEffect } from 'react';

const svgContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '2rem'
};

function AuthCheckYourPhone({ navigate }) {
  const phoneNumber = window.AppConfigState?.magic_link?.phone_number;
  const [resendDisabled, setResendDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [nextAttempt, setNextAttempt] = React.useState(
    new Date(window.AppConfigState.magic_link.next_attempt)
  );

  const magicLoginResend = async () => {
    setLoading(true);
    const response = await postData({
      url: AUTH_MAGIC_LINK_LOGIN_RESEND,
      body: {}
    });

    setNextAttempt(new Date(response.data.next_attempt));

    setLoading(false);
    if (response.data?.error) {
      window.toastr.error(response.data?.error);
    }
    if (response.data?.message) {
      window.toastr.success(null, response.data.message);
    }
    if (response.data?.redirect) {
      navigate(response.data.redirect);
    }
  };

  useEffect(() => {
    const delay = nextAttempt - new Date();
    if (delay > 0) {
      setResendDisabled(true);
      setTimeout(() => {
        setResendDisabled(false);
      }, delay);
    } else {
      setResendDisabled(false);
    }
  }, []);

  return (
    <AuthLayout
      subHeaderStyles={{ textAlign: 'justify' }}
      title='Check Your Phone'
      subTitle='Thanks! If this phone number is associated with an account, we will send you a link to log into your account. '
    >
      <>
        <div css={[loginNoticeStyles, { textAlign: 'center' }]}>
          This link will expire in 30 minutes.
        </div>
        <div
          css={{ fontWeight: '700', fontSize: '1.25rem', textAlign: 'center' }}
        >
          {formatPhoneNumber(phoneNumber)}
        </div>
        <div css={svgContainerStyles}>
          <CheckPhone />
        </div>
        <div css={buttonContainerStyles}>
          <Button
            css={loginButtonStyles}
            disabled={resendDisabled}
            onClick={magicLoginResend}
            loading={loading}
          >
            Resend Text
          </Button>
        </div>
      </>
      <div css={ctaContainerStyles}>
        <Button
          css={{ width: '100%', marginTop: '1.5rem' }}
          onClick={() => navigate(AUTH_MAGIC_LINK_LOGIN)}
        >
          Return to Previous Page
        </Button>
        <LinkButton
          lightBackground
          additionalStyle={linkButtonStyles}
          onClick={() => navigate(AUTH_EMAIL_LOGIN)}
        >
          Return to login with email and password
        </LinkButton>
      </div>
    </AuthLayout>
  );
}

export default AuthCheckYourPhone;
